import {openDrugsCategoryDrawer} from '@/modules/basic-data/categories/components/drugs-category-drawer/util'
import {DataList, DataListItem} from '@cypro/ui/components/ui/data-list'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {Status} from '@cypro/ui/components/ui/status'
import {DrugsCategoryTag} from '@/shared/components/ui/tags/drugs-category-tag'
import {UserTag} from '@/shared/components/ui/tags/user-tag'
import {useDrugsCategoryContext} from '@/shared/contexts/drugs-category'
import {getDatetimeFormatter} from '@cypro/ui/utils'
import {Box, Stack, Tabs, Text} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'
import {LuChevronRight} from 'react-icons/lu'

export function AboutTab() {
  const {t} = useTranslate('common')
  const {category, isSubcategory} = useDrugsCategoryContext()

  const aboutItems = useMemo(() => {
    const value: DataListItem[] = [
      {label: isSubcategory ? t('subcategory_id') : t('category_id'), value: category.id},
      {label: t('name'), value: category.name},
    ]

    if (isSubcategory) {
      value.push({
        label: t('category'),
        value: category.parent ? <DrugsCategoryTag category={category.parent} /> : null,
      })
    }

    value.push(
      {label: t('description'), value: category.description},
      {label: t('created_by'), value: category.created ? <UserTag user={category.created} /> : ''},
      {label: t('date'), value: category.createdAt ? getDatetimeFormatter().format(category.createdAt) : ''}
    )

    return value
  }, [t, category, isSubcategory])

  return (
    <Tabs.Content value="about" spaceY="8" display="flex" flexDirection="column">
      <DataSection label={t('about')}>
        <DataList items={aboutItems} />
      </DataSection>

      {Boolean(category.children?.length) && (
        <DataSection label={t('subcategories')}>
          <Stack width="100%" alignItems="center">
            {category.children?.map(child => (
              <Box
                key={child.id}
                as="button"
                display="flex"
                gapX="0"
                width="100%"
                cursor="pointer"
                onClick={() => openDrugsCategoryDrawer(child)}
              >
                <Box padding="3">
                  <Status value={child.status === 'active' ? 'success' : 'error'} />
                </Box>

                <Box
                  width="100%"
                  padding="3"
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  textAlign="start"
                >
                  <Text fontSize="sm">{child.name}</Text>
                  <Text fontSize="xs" color="fg.muted" wordBreak="break-word">
                    {child.description}
                  </Text>
                </Box>

                <Box padding="3" color="fg.subtle">
                  <LuChevronRight size={20} />
                </Box>
              </Box>
            ))}
          </Stack>
        </DataSection>
      )}
    </Tabs.Content>
  )
}
